import { render } from "./Search.vue?vue&type=template&id=59372b02"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"
script.render = render

export default script